import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const luminousSettings = defineIntegrationSettings({
  fields: {
    apiDomain: z.string().trim().min(1, "API domain is required"),
    locationId: z.string().trim().min(1, "Location ID is required"),
    warehouseId: z.string().trim().min(1, "Warehouse ID is required"),
  },
  secrets: {
    accessToken: z.string().trim().min(1, "Access token is required"),
  },
  connectOnly: {},
  computed: {},
});
